import React, { ReactElement } from "react";
import { AudienceBrandAffinity } from "src/api/types/artist-audience-breakdown";
import { Card, Table, Progress } from "antd";
import { ColumnsType } from "antd/es/table";
import colors from "src/colors";
import { EmotionJSX } from "@emotion/react/types/jsx-namespace";
import styles from "../styles";

interface IProps {
  audienceBrandAffinity: AudienceBrandAffinity[] | undefined;
}

interface Brand {
  rank: number;
  name: string;
  percent: EmotionJSX.Element;
}

const BrandAffinityCard = ({ audienceBrandAffinity }: IProps): ReactElement => {
  let brandAffinity = null;
  if (audienceBrandAffinity) {
    const data = audienceBrandAffinity.map((d) => {
      return {
        rank: audienceBrandAffinity.indexOf(d) + 1,
        name: d.name,
        percent: (
          <div css={{ width: 130 }}>
            <Progress
              strokeColor={colors.blue.light}
              strokeWidth={12}
              percent={Number(d.percent)}
            />
          </div>
        ),
      };
    });
    const columns: ColumnsType<Brand> = [
      {
        title: "Rank",
        dataIndex: "rank",
        key: "rank",
      },
      {
        title: "Brand",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Percent Interested",
        dataIndex: "percent",
        key: "percent",
        align: "right",
      },
    ];
    brandAffinity = (
      <Card css={styles.smallCard}>
        <h4>BRAND AFFINITY</h4>
        <Table
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "grayrow")}
          size="small"
          columns={columns}
          dataSource={data}
        />
      </Card>
    );
  }

  return <>{brandAffinity}</>;
};

export default BrandAffinityCard;
